import { render, staticRenderFns } from "./StockBrowserSkuSingle.vue?vue&type=template&id=4952c434&scoped=true&"
import script from "./StockBrowserSkuSingle.vue?vue&type=script&lang=js&"
export * from "./StockBrowserSkuSingle.vue?vue&type=script&lang=js&"
import style0 from "./StockBrowserSkuSingle.vue?vue&type=style&index=0&id=4952c434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952c434",
  null
  
)

export default component.exports